module.exports = __webpack_public_path__ + "img/bg.054bd4bc.jpg";